import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
import { getCompanySystemTitle } from '../../../components/company-system-title/CompanySystemTitle';
import apiClient from '../../../components/ApiClient/ApiClient';
// mocks_
import account from '../../../_mock/account';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const [isSwitching, setIsSwitching] = useState(false);
  const navigate = useNavigate();
  const companySystemTitle = getCompanySystemTitle();
  const currentCompany = (sessionStorage.getItem('company') || '').trim().toUpperCase();
  const targetCompany = currentCompany === 'FM' ? 'HC' : 'FM';
  const targetSystemTitle = targetCompany === 'FM' ? '福蒙系統' : '華辰系統';

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleLoginOut = () => {
    sessionStorage.clear();
    setOpen(null);
    navigate('/login', { replace: true });
  };
  const handleSwitchCompany = async () => {
    if (isSwitching || !window.confirm(`確定切換至${targetSystemTitle}？`)) return;
    setIsSwitching(true);
    try {
      const response = await apiClient.post('/Login/SwitchCompany', { targetCompany });
      const switched = response.data?.data;
      if (!response.data?.success || !switched?.token) throw new Error(response.data?.message || '公司切換失敗。');
      sessionStorage.setItem('token', switched.token);
      sessionStorage.setItem('company', switched.company);
      sessionStorage.setItem('Id', switched.id);
      sessionStorage.setItem('userSN', switched.role);
      sessionStorage.setItem('Can', switched.canCRUDuser);
      sessionStorage.setItem('userName', switched.userName);
      setOpen(null);
      window.location.replace('/dashboard/products');
    } catch (error) {
      if (error.response?.status !== 401 && error.response?.status !== 403)
        window.alert(error.response?.data?.message || error.message || '公司切換失敗。');
      setIsSwitching(false);
    }
  };
  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            { sessionStorage.getItem('userName')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            目前系統：{companySystemTitle}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClose(option.label)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleSwitchCompany} disabled={isSwitching} sx={{ m: 1 }}>
          {isSwitching ? '切換中…' : `切換至${targetSystemTitle}`}
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLoginOut} sx={{ m: 1 }}>
          登出
        </MenuItem>
      </Popover>
    </>
  );
}
